import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

// /settings/webchat — marca e domínio do webchat de continuidade, com
// preview ao vivo da tela do cliente. Só admin, como as páginas de conta.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/webchat'),
      name: 'webchat_settings_index',
      meta: {
        featureFlag: FEATURE_FLAGS.WEBCHAT,
        permissions: ['administrator'],
      },
      // Lazy: a página (form + preview) só entra no bundle de quem abre.
      component: () => import('./Index.vue'),
    },
  ],
};
